"use strict";

var _regeneratorRuntime = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Collections_1 = __importDefault(require("./Collections"));

var Overrides_1 = __importDefault(require("./Overrides"));

var Override = /*#__PURE__*/function () {
  function Override(collectionName, overrideId, apiCall) {
    _classCallCheck(this, Override);

    this.collectionName = collectionName;
    this.overrideId = overrideId;
    this.apiCall = apiCall;
  }

  _createClass(Override, [{
    key: "retrieve",
    value: function () {
      var _retrieve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.apiCall.get(this.endpointPath()));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function retrieve() {
        return _retrieve.apply(this, arguments);
      }

      return retrieve;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.apiCall.delete(this.endpointPath()));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _delete() {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "endpointPath",
    value: function endpointPath() {
      return "".concat(Collections_1.default.RESOURCEPATH, "/").concat(this.collectionName).concat(Overrides_1.default.RESOURCEPATH, "/").concat(this.overrideId);
    }
  }]);

  return Override;
}();

exports.default = Override;